"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertNumberToDecimalPercentage = convertNumberToDecimalPercentage;
/**
 * Converts a standard number representing a percentage (e.g., 15 for 15%)
 * into a branded DecimalPercentage type (e.g., 0.15).
 * @param value The percentage value (e.g., 15)
 * @returns The value converted to a decimal and branded (e.g., 0.15 as DecimalPercentage)
 */
function convertNumberToDecimalPercentage(value) {
    if (value < 0) {
        throw new Error(`Input value ${value} is negative.`);
    }
    if (value <= 1 && value !== 0) {
        console.warn(`Input value ${value} is between 0 and 1. Ensure you are passing the original percentage (e.g., 15) and not a pre-calculated decimal.`);
    }
    const decimalValue = value / 100;
    return decimalValue;
}
//# sourceMappingURL=convert-number-to-decimal-percentage.js.map